import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import { AxiosResponse } from "axios"
import {
  TInvoiceHeaderListGetRes,
  TInvoiceHeaderListGetReq,
  TInvoiceHeaderListPutReq,
  TInvoiceHeaderDeleteReq,
} from "./TInvoice"

/**
 * 請求書表紙編集画面／請求書表紙手作成画面に対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class InvoiceHeaderService extends ConnectApi {
  /**
   * 単体取得
   *
   * @param {TInvoiceHeaderListGetReq} params
   * @memberof invoiceHeaderService
   */
  get = async (params: TInvoiceHeaderListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TInvoiceHeaderListGetRes[]>> =
        await this.getInner(`/billing/seikyusyohyosihensyu`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体更新
   *
   * @param {TInvoiceHeaderListPutReq} data
   * @param {(param: TApiResponse<TInvoiceHeaderListGetRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TInvoiceHeaderListGetRes>>) => any} reject
   * @memberof invoiceHeaderService
   */
  put = async (id: number, data: TInvoiceHeaderListPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/billing/seikyusyohyosihensyu/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 請求書表紙手作成
   *
   * @param {TInvoiceHeaderListPutReq} data
   * @param {(param: TApiResponse<TInvoiceHeaderListGetRes[]>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TInvoiceHeaderListGetRes[]>>) => any} reject
   * @memberof invoiceHeaderService
   */
  putMakeHeader = async (id: number, data: TInvoiceHeaderListPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TInvoiceHeaderListGetRes[]>> =
        await this.putInner(`/billing/seikyusyohyositesakusei/${id}`, data)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 請求書表紙手作成
   *
   * @param {TInvoiceHeaderListPutReq} data
   * @param {(param: TApiResponse<TInvoiceHeaderListGetRes[]>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TInvoiceHeaderListGetRes[]>>) => any} reject
   * @memberof invoiceHeaderService
   */
  delete = async (id: number, data: TInvoiceHeaderDeleteReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.deleteInner(
        `/billing/seikyugoukei/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
